import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, TableElement } from "@easy-email-pro-core/typings";
import { BasicBlock, ContentLeaf } from "@easy-email-pro-core/components";
import React from "react";
import he from "he";

const defaultData: ElementDefinition<TableElement>["defaultData"] = {
  attributes: {
    align: "left",
    border: "none",
    cellpadding: "0",
    cellspacing: "0",
    color: "#000000",
    "font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    "font-size": "13px",
    "line-height": "22px",
    padding: "10px 25px",
    "padding-top": "10px",
    "padding-right": "25px",
    "padding-bottom": "10px",
    "padding-left": "25px",
    "table-layout": "auto",
    width: "100%",
  },
  data: {
    code: "",
  },
};

export const Table = createBlock<TableElement>({
  get name() {
    return t("Table");
  },
  defaultData,
  type: BasicType.TABLE,
  create: (payload) => {
    const data: TableElement = {
      type: BasicType.TABLE,
      data: {
        code: "",
      },
      attributes: {
        ...defaultData.attributes,
      },
      children: [],
    };
    return mergeBlock(data, payload);
  },
  category: ElementCategory.TABLE,
  render(params) {
    const isProduction = params.mode === "production";
    const code = params.node.data.code;
    return (
      <BasicBlock
        params={params}
        tag="mj-table"
        children={
          params.children || (
            <ContentLeaf
              node={{
                text: isProduction ? code : he.encode(code),
              }}
            />
          )
        }
      />
    );
  },
});
